import type { HTMLAttributes, MouseEventHandler, ReactNode } from 'react';

export type CardSize = 'small' | 'medium' | 'large' | 'fullscreen';

export interface CardTab {
  content: ReactNode;
  active?: boolean;
  onClick?: MouseEventHandler;
  rightPinned?: boolean;
  centered?: boolean;
  disabled?: boolean;
}

export interface CardData {
  size?: CardSize;
  noPadding?: boolean;
  isModal?: boolean;
}

export interface CardProps extends CardData, HTMLAttributes<HTMLDivElement> {
  containerProps?: HTMLAttributes<HTMLDivElement>;
}
